import axios from "axios";
import routers from '../router/routers'
import store from "../store";
import {errorMsg} from "./message";

//  创建axios实例
const instance = axios.create({
    baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_URL : '/api', timeout: 60000   //  请求超时时间（毫秒）
})

//  request拦截器
instance.interceptors.request.use(config => {
    //  如果已登录
    if (store.state.token) {
        //  在请求头添加token
        config.headers['Authorization'] = 'Bearer ' + store.state.token
    }
    //  统一请求类型json
    config.headers['Content-Type'] = 'application/json'
    return config
}, error => {
    Promise.reject(error)
})

//  response拦截器
instance.interceptors.response.use(response => {
    let rep = response.data;
    if (!rep) {
        errorMsg("服务器无响应")
        return Promise.reject("服务器无响应")
    } else {
        if (rep?.type === "application/vnd.ms-excel") {
            return rep.data;
        }
        let status = rep.status;
        if (status === "success") {
            //走then
            return rep.data;
        } else if (status === "invalid") {
            //  清空token
            store.dispatch('tokenAction', null)
            //  并跳转到登录页面，进行重新登录
            routers.push({
                path: '/login', query: {
                    backto: routers.currentRoute.fullPath
                }
            })
        } else if (status === "forbidden") {
            //  直接跳转至401页面
            routers.replace({path: '/401'})
        } else if (status === "fail") {
            errorMsg(rep.message)
            return Promise.reject(rep)
        }{
            return rep;
        }
    }
}, error => {
    let message = "加载失败";
    if (error && error.response) {
        switch (error.response.status) {
            case 400:
                message = "请求错误";
                break;
            case 401:
                message = "未授权，请登录";
                break;
            case 403:
                message = "拒绝访问";
                break;
            case 404:
                message = "请求地址出错";
                break;
            case 408:
                message = "请求超时";
                break;
            case 413:
                message = "文件大小不能超过5M";
                break;
            case 500:
                message = "服务器内部错误";
                break;
            case 501:
                message = "服务未实现";
                break;
            case 502:
                message = "网关错误";
                break;
            case 503:
                message = "服务不可用";
                break;
            case 504:
                message = "网关超时";
                break;
            case 505:
                message = "HTTP版本不受支持";
                break;
            default:
                message = "加载失败";
        }
    }
    errorMsg(message)
    return Promise.reject(message)
})

export default instance
